import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { useModal } from '@/hooks/useModal';
import { getAccount, useAccount } from '@/resource/account';
import { isFavoriteAd, type AdItemType } from '@/resource/ad';
import { addFavorite, removeFavorite } from '@/resource/favorites';
import { useBoolean } from 'usehooks-ts';

export function FavoriteButton({ ad }: { ad: AdItemType }) {
  const modal = useModal();
  const account = useAccount();
  const isFavorite = isFavoriteAd(account, ad);
  const { profile } = account;
  const label = ad.type === 'offer' ? 'aanbod' : 'vraag';
  const posting = useBoolean(false);

  return (
    <Button
      theme={isFavorite ? 'primary' : 'secondary'}
      icon="heart_outline"
      iconOnly="mobile"
      disabled={posting.value}
      onClick={(e, refocus) => {
        if (!profile) {
          modal.open(
            {
              type: 'login',
              props: {
                title: `Om een ${label} op te slaan moet je ingelogd zijn`,
              },
            },
            refocus
          );
        } else if (profile.deactivated) {
          modal.open(
            {
              type: 'message',
              props: {
                title: 'Je account is gedeactiveerd',
                description: (
                  <Text align="center">
                    <Link to={{ type: 'profile_status' }} underline>
                      Heractiveer je account
                    </Link>{' '}
                    om een {ad.type === 'offer' ? 'aanbod' : 'vraag'} op te
                    slaan.
                  </Text>
                ),
              },
            },
            refocus
          );
        } else {
          posting.setTrue();
          if (isFavorite) {
            removeFavorite(ad)
              .then(() => getAccount().finally(posting.setFalse))
              .catch(posting.setFalse);
          } else {
            addFavorite(ad)
              .then(() => getAccount().finally(posting.setFalse))
              .catch(posting.setFalse);
          }
        }
      }}
    >
      {isFavorite ? `Opgeslagen` : `Bewaar ${label}`}
    </Button>
  );
}
